import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, FormattedNumber } from 'react-intl';

export const detailsTitle = (
    <FormattedMessage id="pdpDetails.detailsTitle" defaultMessage="Details" />
);

export const conditionTitle = (
    <FormattedMessage id="pdpDetails.conditionTitle" defaultMessage="Condition" />
);

export const conditionDetailsTitle = (
    <FormattedMessage id="pdpDetails.conditionDetailsTitle" defaultMessage="Condition Details" />
);

export const artistTitle = <FormattedMessage id="pdpDetails.artistTitle" defaultMessage="Artist" />;

export const brandTitle = <FormattedMessage id="pdpDetails.brandTitle" defaultMessage="Brand" />;

export const chestTitle = <FormattedMessage id="pdpDetails.chestTitle" defaultMessage="Bust" />;

export const creationYearTitle = (
    <FormattedMessage id="pdpDetails.creationYearTitle" defaultMessage="Creation year" />
);

export const creatorTitle = (
    <FormattedMessage id="pdpDetails.creatorTitle" defaultMessage="Creator" />
);

export const dateOfManufactureTitle = (
    <FormattedMessage id="pdpDetails.dateOfManufactureTitle" defaultMessage="Date of manufacture" />
);

export const dealerLocationTitle = (
    <FormattedMessage id="pdpDetails.dealerLocationTitle" defaultMessage="Dealer Location" />
);

export const dealerReferenceTitle = (
    <FormattedMessage
        id="pdpDetails.dealerReferenceTitle"
        defaultMessage="Seller reference number"
    />
);

export const designerTitle = (
    <FormattedMessage id="pdpDetails.designerTitle" defaultMessage="Designer" />
);

export const diameterTitle = (
    <FormattedMessage id="pdpDetails.diameterTitle" defaultMessage="Diameter" />
);

export const dimensionsTitle = (
    <FormattedMessage id="pdpDetails.dimensionsTitle" defaultMessage="Dimensions" />
);

export const galleryLocationTitle = (
    <FormattedMessage id="pdpDetails.galleryLocationTitle" defaultMessage="Gallery location" />
);

export const genderTitle = <FormattedMessage id="pdpDetails.genderTitle" defaultMessage="Gender" />;

export const hipTitle = <FormattedMessage id="pdpDetails.hipTitle" defaultMessage="Hip" />;

export const inseamTitle = <FormattedMessage id="pdpDetails.inseamTitle" defaultMessage="Inseam" />;

export const itemLocationTitle = (
    <FormattedMessage id="pdpDetails.itemLocationTitle" defaultMessage="Item location" />
);

export const leadTimeTitle = (
    <FormattedMessage id="pdpDetails.leadTimeTitle" defaultMessage="Production time" />
);

export const availableNowValue = (
    <FormattedMessage id="pdpDetails.availableNowValue" defaultMessage="Available Now" />
);

export const LeadTimeValue = ({ leadTime }) => (
    <FormattedMessage
        id="pdpDetails.leadTimeValue"
        defaultMessage="It will take {leadTime} to make this piece"
        values={{ leadTime }}
    />
);

LeadTimeValue.propTypes = {
    leadTime: PropTypes.string.isRequired,
};

export const lengthTitle = <FormattedMessage id="pdpDetails.lengthTitle" defaultMessage="Length" />;

export const markedSizeTitle = (
    <FormattedMessage id="pdpDetails.markedSizeTitle" defaultMessage="Marked size" />
);

export const materialNotesTitle = (
    <FormattedMessage id="pdpDetails.materialNotesTitle" defaultMessage="Material notes" />
);

export const materialsAndTechniquesTitle = (
    <FormattedMessage
        id="pdpDetails.materialsAndTechniquesTitle"
        defaultMessage="Materials and techniques"
    />
);

export const mediumTitle = <FormattedMessage id="pdpDetails.mediumTitle" defaultMessage="Medium" />;

export const metalTitle = <FormattedMessage id="pdpDetails.metalTitle" defaultMessage="Metal" />;

export const inTheStyleOfTitle = (
    <FormattedMessage id="pdpDetails.inTheStyleOfTitle" defaultMessage="In the Style Of" />
);

export const ofThePeriodTitle = (
    <FormattedMessage id="pdpDetails.ofThePeriodTitle" defaultMessage="Of the Period" />
);

export const movementAndStyleTitle = (
    <FormattedMessage id="pdpDetails.movementAndStyleTitle" defaultMessage="Movement & Style" />
);

export const setSizeTitle = (
    <FormattedMessage id="pdpDetails.setSizeTitle" defaultMessage="Sold As" />
);

export const setSizeContent = setSize => (
    <FormattedMessage
        values={{ setSize: <FormattedNumber value={setSize} /> }}
        id="pdpDetails.setSizeContent"
        defaultMessage="Set of {setSize}"
    />
);

export const originTitle = (
    <FormattedMessage id="pdpDetails.originTitle" defaultMessage="Place of origin" />
);

export const periodTitle = <FormattedMessage id="pdpDetails.periodTitle" defaultMessage="Period" />;

export const productionTypeTitle = (
    <FormattedMessage id="pdpDetails.productionTypeTitle" defaultMessage="Production type" />
);

export const referenceNumberTitle = (
    <FormattedMessage id="pdpDetails.referenceNumberTitle" defaultMessage="Reference number" />
);

export const seatHeightTitle = (
    <FormattedMessage id="pdpDetails.seatHeightTitle" defaultMessage="Seat height" />
);

export const sellerLocationTitle = (
    <FormattedMessage id="pdpDetails.sellerLocationTitle" defaultMessage="Seller location" />
);

export const shoulderToHemTitle = (
    <FormattedMessage id="pdpDetails.shoulderToHemTitle" defaultMessage="Shoulder to Hem" />
);

export const stoneTitle = <FormattedMessage id="pdpDetails.stoneTitle" defaultMessage="Stone" />;

export const stoneCutTitle = (
    <FormattedMessage id="pdpDetails.stoneCutTitle" defaultMessage="Stone Cut" />
);

export const versionsTitle = (
    <FormattedMessage id="pdpDetails.versionsTitle" defaultMessage="More editions & sizes" />
);

export const waistTitle = <FormattedMessage id="pdpDetails.waistTitle" defaultMessage="Waist" />;

export const wearTitle = <FormattedMessage id="pdpDetails.wearTitle" defaultMessage="Wear" />;

export const weightTitle = <FormattedMessage id="pdpDetails.weightTitle" defaultMessage="Weight" />;

export const GenderValue = ({ gender }) => (
    <FormattedMessage
        id="pdpDetails.genderValue"
        defaultMessage={`
            {gender, select,
                MALE {Male}
                FEMALE {Female}
                other {Unisex}
            }
        `}
        values={{ gender }}
    />
);

GenderValue.propTypes = {
    gender: PropTypes.string.isRequired,
};

export const deliveryReturnsTitle = (
    <FormattedMessage id="pdpDetails.deliveryReturnsTitle" defaultMessage="Shipping & Returns" />
);

export const deliveryTitle = (
    <FormattedMessage id="pdpDetails.deliveryTitle" defaultMessage="Shipping" />
);

export const methodNote = (
    <FormattedMessage
        id="shippingHelpers.methodNote"
        defaultMessage="Shipping methods are determined by item size, type, fragility and specific characteristics."
    />
);

export const methodNoteFreeShipping = (
    <FormattedMessage
        id="shippingHelpers.methodNoteFreeShipping"
        defaultMessage="We recommend this shipping type based on item size, type and fragility."
    />
);

export const costNote = (
    <FormattedMessage
        id="shippingHelpers.costNote"
        defaultMessage="Shipping costs are calculated based on carrier rates, delivery distance and packing complexity."
    />
);

export const paymentsTitle = (
    <FormattedMessage id="pdpDetails.paymentsTitle" defaultMessage="Online Payment Methods" />
);

export const invoiceTitle = (
    <FormattedMessage id="pdpDetails.invoiceTitle" defaultMessage="Item Invoice" />
);

export const requestQuoteNotice = (
    <FormattedMessage
        id="pdpMobileShippingHelpers.request_quote_notice"
        defaultMessage="Some items may require special handling and packaging. Request a shipping quote to see what options are available to your destination."
    />
);
